// Menu and pricing data for restaurant, laundry, etc.

export const HOURS = {
  breakfast: "08:00 – 10:30",
  main: "10:30 – 20:30",
};

export const BREAKFAST = [
  { id: "omelette", name: "The Homestay Omelette", price: 75000, desc: "Omelette with spinach, cheese and onion served with sourdough toast." },
  { id: "big-breakfast", name: "Garden Big Breakfast", price: 75000, desc: "Chicken sausage, grilled tomato, two sunny-side eggs and toast." },
  { id: "sunrise", name: "Sunrise Fried Rice or Noodles", price: 75000, desc: "Indonesian fried rice or noodles served with egg, crackers and cucumber." },
  { id: "smoothie-bowl", name: "Morning Smoothie Bowl", price: 70000, desc: "Dragon fruit and banana smoothie with granola and fresh fruits." },
];

// Indonesian comfort food
export const INDONESIAN = [
  { name: "Ayam Goreng Sambal Matah", price: 45000, desc: "Crispy fried chicken served with Balinese sambal matah, rice & fresh vegetables." },
  { name: "Nasi Goreng Nusantara", price: 45000, desc: "Indonesian fried rice served with egg, crackers and fresh cucumber." },
  { name: "Mie Goreng Nusantara", price: 45000, desc: "Indonesian fried noodles with egg, vegetables and crackers." },
  { name: "Soto Ayam", price: 45000, desc: "Traditional Indonesian chicken soup with rice, turmeric broth & fresh herbs." },
];

// Western comfort food
export const WESTERN = [
  { name: "Spaghetti Aglio e Olio", price: 55000, desc: "Garlic, olive oil, chili flakes & parmesan cheese." },
  { name: "Chicken Alfredo Spaghetti", price: 60000, desc: "Creamy parmesan sauce served with grilled chicken." },
  { name: "Spaghetti Margherita", price: 55000, desc: "Tomato basil sauce with parmesan cheese." },
  { name: "Crispy Chicken Margherita", price: 60000, desc: "Crispy fried chicken served with tomato basil sauce." },
  { name: "Chicken Caesar Salad", price: 60000, desc: "Fresh romaine lettuce, grilled chicken, parmesan cheese & Caesar dressing." },
  { name: "Chicken Club Sandwich", price: 60000, desc: "Toast bread with grilled chicken, egg, lettuce, tomato & mayonnaise served with fries." },
];

export const SNACKS = [
  { name: "Crispy Garlic Chicken Wings", price: 40000, desc: "Crispy chicken wings with garlic seasoning served with chili sauce." },
  { name: "French Fries", price: 40000, desc: "Crispy golden fries served with tomato sauce." },
];

export const DESSERTS = [
  { name: "Pisang Goreng", price: 30000, desc: "Balinese fried banana served warm." },
  { name: "Tropical Fruit Platter", price: 30000, desc: "Selection of fresh seasonal tropical fruits." },
  { name: "Sunflower Cakes (Jaje Matahari Bali)", price: 20000, desc: "Traditional Balinese sweet snack — 3 pieces." },
];

// Coffee with hot / ice pricing
export const COFFEE = [
  { name: "Espresso", hot: 40000, ice: 45000 },
  { name: "Americano", hot: 40000, ice: 45000 },
  { name: "Cappuccino", hot: 40000, ice: 45000 },
  { name: "Latte", hot: 40000, ice: 45000 },
  { name: "Bali Coffee", hot: 25000, ice: null, note: "Hot only" },
  { name: "Palm Sugar Latte", hot: 40000, ice: 45000, signature: true },
];

export const NON_COFFEE = [
  { name: "Tea", hot: 20000, ice: 23000 },
  { name: "Ginger Honey Tea", hot: 25000, ice: 27000 },
  { name: "Matcha Latte", hot: 40000, ice: 45000 },
  { name: "Signature Chocolate", hot: 40000, ice: 45000, signature: true },
];

// Juices
export const JUICES_SIGNATURE = [
  { name: "Sunrise Tropic", price: 45000, ingredients: "orange · carrot · pineapple" },
  { name: "Pink Blossom", price: 45000, ingredients: "watermelon · strawberry · apple" },
  { name: "Fresh Detox", price: 45000, ingredients: "cucumber · apple · lemon" },
  { name: "Golden Health", price: 45000, ingredients: "turmeric · orange · pineapple · honey" },
];

export const JUICES_FRUIT = [
  { name: "Orange Juice", price: 35000 },
  { name: "Watermelon Juice", price: 35000 },
  { name: "Pineapple Juice", price: 35000 },
  { name: "Papaya Juice", price: 35000 },
];

export const SMOOTHIE_BOWLS = [
  { name: "Dragon Smoothie Bowl", price: 60000, desc: "Dragon fruit, banana, berries, granola, coconut, honey." },
  { name: "Banana Smoothie Bowl", price: 60000, desc: "Banana, mango, granola, coconut, honey." },
  { name: "Mixberry Smoothie Bowl", price: 60000, desc: "Berry mix, banana, granola, coconut, honey." },
];

// Laundry pricing (per kg) — Agung Wiwin Laundry
export const LAUNDRY_KILO = [
  { name: "Standard", price: 20000, unit: "/ kg", eta: "2 days finish" },
  { name: "Express 6 Hours", price: 30000, unit: "/ kg", eta: "Wash, dry, fold" },
  { name: "Express 3 Hours", price: 40000, unit: "/ kg", eta: "Wash, dry, fold" },
  { name: "Ironing Only", price: 10000, unit: "/ kg", eta: "Ironing only" },
];

// Shoe cleaning (per pair)
export const LAUNDRY_SHOES = [
  { name: "Standard Shoe Cleaning", price: 50000, unit: "/ pair", eta: "Regular shoe cleaning" },
  { name: "Express 6 Hours Shoe", price: 75000, unit: "/ pair", eta: "Fast shoe cleaning" },
];
